<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="品牌管理" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
						<div class="operator-col">
							<el-input
								size="mini"
								v-model="filterTableSearch"
								placeholder="品牌名"
								suffix-icon="el-icon-search"
								clearable
							></el-input>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
						:search-filter="filterTableSearch"
						:sort-by="{sortKey: 'first',sortOrder: 'asc'}"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
			v-if="editorVisible"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";

export default {
	mixins: [CurdPage, Filters],

	data() {
		return {
			editorDataModel: "Brand",
			tableFields: [
				{
					name: "first",
					sortable: "custom"
				},
				{
					name: "name",
					sortable: "custom"
				},
				{
					name: "main_supplier",
					sortable: false
				},
				{
					name: "classifies",
					sortable: false
				},
				{
					name: "is_focus",
					sortable: "custom"
				},
				{
					name: "is_home",
					sortable: "custom"
				}
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"],
					width: "100%"
				},
				{
					name: "is_focus",
					width: "100%"
				},
				{
					name: "main_supplier"
				},
				{
					name: "classifies",
					params: {
						isCheckbox: true
					}
				},
				{
					name: "intro",
					width: "100%"
				},
				{
					name: "is_home",
					width: "100%"
				}
			]
		};
	}
};
</script>
<style lang="scss" scoped>
</style>
